if (localStorage.getItem("registerPopupShown") === null) {
    localStorage.setItem("registerPopupShown", "true");
}
document.addEventListener("DOMContentLoaded", function() {
    

    const popup = document.getElementById("register-popup");
    const popupClose = document.getElementById("popup-close");
    const loaderMain = document.querySelector(".custom-loader-main");

    // Check if element has attribute data-customer-login
    // if (loaderMain && loaderMain.hasAttribute("data-customer-login")) {
    //     localStorage.setItem("registerPopupShown", "true");
    // } else {
    //     localStorage.setItem("registerPopupShown", "false");
    // }

    // Show popup only if not shown before OR explicitly set to "false"
    if (popup && (!localStorage.getItem("registerPopupShown") || localStorage.getItem("registerPopupShown") === "false")) {
        popup.classList.add("show");
    }

    if (popup && popupClose) {
        popupClose.addEventListener("click", function() {
            popup.classList.remove("show"); // hide popup
            localStorage.setItem("registerPopupShown", "true"); // mark as shown
            // 2.6: Use dynamic exclusive entry collection
            window.location.href = window.exclusiveEntryCollection || "/collections/all";
        });
    }

    // Toggle between login and register forms via hash (no page reload)
    const registerBtn = document.getElementById("register_button");
    if (registerBtn) {
        registerBtn.addEventListener("click", function () {
            window.location.hash = "register";
        });
    }

    const loginBtn = document.getElementById("login_button");
    if (loginBtn) {
        loginBtn.addEventListener("click", function () {
            window.location.hash = "login";
        });
    }


    // Transform SHOP ALL button to "← Back" when login form shows
    let originalShopAllContent = null;

    if(document.querySelector('a[href="#main-login"]')) {
        const shopAllBtn = document.querySelector('a[href="#main-login"]');
        originalShopAllContent = shopAllBtn.innerHTML;

        shopAllBtn.addEventListener('click', function(e) {
            e.preventDefault();
            const loginForm = document.getElementById('main-login');
            loginForm.classList.toggle('active');

            if (loginForm.classList.contains('active')) {
                // Transform to plain "← Back" text
                this.classList.add('back-mode');
                this.innerHTML = '<span class="preloader-btn__label">← Back</span>';
            } else {
                // Restore original SHOP ALL content
                this.classList.remove('back-mode');
                this.innerHTML = originalShopAllContent;
            }
        });
    }

    // Register Form
    
        let mainLogin = document.getElementById('main-login'); 
        if (mainLogin) {
            let type = null;

            if (window.location.href.includes('register')) {
                type = 'register';
            } else if (window.location.href.includes('login')) {
                type = 'login';
            } else if (window.location.href.includes('recover')) {
                type = 'recover';
            }

            if (type) {
                mainLogin.classList.add('active');

                // Keep Shop Exclusive button as "Back" when form is visible on reload
                var shopBtn = document.querySelector('a[href="#main-login"]');
                if (shopBtn) {
                    shopBtn.classList.add('back-mode');
                    var label = shopBtn.querySelector('.preloader-btn__label');
                    if (label) label.textContent = '\u2190 Back';
                    var micro = shopBtn.querySelector('.preloader-btn__microcopy');
                    if (micro) micro.style.display = 'none';
                }
            }
        }


    // Field validation helpers
    function getErrorSpan(field) {
        var next = field.nextElementSibling;
        return (next && next.classList.contains('field-error')) ? next : null;
    }

    function validateField(input) {
        var value = input.value.trim();
        var field = input.closest('.field');
        var errorSpan = field ? getErrorSpan(field) : null;
        var message = '';

        if (!value) {
            message = 'This field is required';
        } else if (input.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            message = 'Please enter a valid email';
        }

        if (errorSpan) errorSpan.textContent = message;
        if (field) {
            if (message) {
                field.classList.add('field--error');
            } else {
                field.classList.remove('field--error');
            }
        }
        return !message;
    }

    function validateForm(form) {
        var inputs = form.querySelectorAll('input:not([type="hidden"]):not([type="checkbox"])');
        var valid = true;
        inputs.forEach(function(input) {
            if (!validateField(input)) valid = false;
        });
        return valid;
    }

    // Clear field errors on input
    document.querySelectorAll('#main-login .field input').forEach(function(input) {
        input.addEventListener('input', function() {
            var field = this.closest('.field');
            var errorSpan = field ? getErrorSpan(field) : null;
            if (errorSpan) errorSpan.textContent = '';
            if (field) field.classList.remove('field--error');
        });
    });

    // Red borders for server-side errors rendered by Liquid on page load
    document.querySelectorAll('#main-login .field-error').forEach(function(span) {
        if (span.textContent.trim()) {
            var field = span.previousElementSibling;
            if (field && field.classList.contains('field')) {
                field.classList.add('field--error');
            }
        }
    });

    // Login Form - Add Enter key support (since button is now <a> tag)
    const loginForm = document.querySelector('#customer_login');
    if (loginForm) {
        loginForm.addEventListener('keypress', function(e) {
            if (e.key === 'Enter') {
                e.preventDefault();
                this.dispatchEvent(new Event('submit'));
            }
        });
    }

    // Login Form submit handler
    if (document.querySelector('#customer_login')){
    document.querySelector('#customer_login').addEventListener('submit', function(e) {
        e.preventDefault();
        let form = e.target;

        // Validate fields before submitting
        if (!validateForm(form)) return;

        fetch('/account/login', {
            method: 'POST',
            body: new FormData(form),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.text())
        .then(html => {
            // Extract error messages from the returned HTML
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, 'text/html');
            let errors = doc.querySelector('.form__message');

            if (errors) {
                // Show error under password field with red border
                let pwField = form.querySelector('#CustomerPassword');
                if (pwField) {
                    let field = pwField.closest('.field');
                    let errorSpan = field ? getErrorSpan(field) : null;
                    if (errorSpan) errorSpan.textContent = 'Incorrect email or password';
                    if (field) field.classList.add('field--error');
                }
            } else {
                // 2.6: Use dynamic exclusive entry collection
                window.location.href = window.exclusiveEntryCollection || '/collections/all';
            }
        });
    });
    }

    if(document.querySelector('#create_customer')){
        document.querySelector('#create_customer').addEventListener('submit', function(e) {
            // Validate fields before submitting
            if (!validateForm(this)) {
                e.preventDefault();
                return;
            }
            localStorage.setItem("registerPopupShown", "false");
        });
    }
    
});